export const isImage = (url: string) => {
  return /\.(jpg|jpeg|png)$/i.test(url);
};
